import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'

// import BkFlowPromoInput from './BkFlowPromoInput'
import BkFlowSidebarRoomCard from './room/BkFlowSidebarRoomCard'
import BkFlowSidebarPolicies from './policies/BkFlowSidebarPolicies'
import BkFlowRestaurantsPaymentCards from '../../restaurants/BkFlowRestaurantsPaymentCards'
import BkFlowMaterialLoader from '../../elements/BkFlowMaterialLoader'

import formatPrice from '../../../utilities/currency/formatPrice'
import {formatRoundPrice} from '../../../utilities/currency/formatPrice'
import getCurrencySymbol from '../../../utilities/currency/getCurrencySymbol'

import moment from 'moment'

import '../../../styles/css/components/payment/bk-flow-sidebar-policies.css'

import _ from 'lodash'
import yn from 'yn'

class BkFlowPaymentSidebar extends Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	renderSidebar = () => {
		const {
			configData,
			availabilityLoading,
			activeEnhancementData,
			activeRoom,
			activeRestaurantsData,
			activeCurrencyData,
			roomRateDetailsData,
			urlData
		} = this.props

		const hotelLabels = configData.hotel.labels[0]
		// const totalNights = moment(urlData.endDate).diff(moment(urlData.startDate), 'days')

		let activeHotelCode = null
		let matchedProperty = null
		let highlightedTaxesFees = null
		let propertyClassType = 20
		let destinationFeeAmount = null

		// Get hotel code from avail response
		if (!_.isEmpty(urlData) && urlData.hotelCode) {
			activeHotelCode = urlData.hotelCode
		}

		const hideTaxes = activeHotelCode === 'B5C3';

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			matchedProperty = configProperties.find(function (property) {
				return property.hotelCode === String(activeHotelCode)
			})
		}

		if (
			matchedProperty &&
			matchedProperty.highlightTaxTypes
		) {
			highlightedTaxesFees = matchedProperty.highlightTaxTypes
		}

		if (
			matchedProperty &&
			matchedProperty.propertyClassType
		) {
			propertyClassType = Number(matchedProperty.propertyClassType)
		}

		if (availabilityLoading) {
			return  <BkFlowMaterialLoader />
		} else if (activeRoom) {

			// Init Structures
			let roomRateData = []
			let renderRoomRate = ''
			let roomTaxesFeesData = []
			let renderRoomTax = '--'
			let roomFeesOnlyData = []
			let renderRoomFeesOnly = '--'
			let roomTaxesOnlyData = []
			let renderRoomTaxOnly = '--'
			let roomTotalData = []
			let enhancementTotalData = []
			let grandTotalData = []
			let renderGrandTotal = ''
			let renderRoomFees = []

			const currencyCode = activeRoom[0][1][0].rates[0].total.currencyCode
			const currencySymbol = getCurrencySymbol(currencyCode)

			let renderCurrencyCode = <span className="u-price-line__currency-code">{ currencyCode }</span>

			if (
				yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
				activeCurrencyData &&
				activeCurrencyData.currencyCode
			) {
				renderCurrencyCode = <span className="u-price-line__currency-code">{ activeCurrencyData.currencyCode }</span>
			}

			const addTotals = (a, b) => a + b

			for (let roomKey in activeRoom) {

				// Build Room Rate
				if (activeRoom[roomKey][1][0].rates[0].total.amountBeforeTax) {
					roomRateData.push(Number(activeRoom[roomKey][1][0].rates[0].total.amountBeforeTax))
					const roomRateSum = roomRateData.reduce(addTotals, 0)

					if (
						yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX)&&
						activeCurrencyData &&
						activeCurrencyData.exchangeRate &&
						activeCurrencyData.currencyCode
					) {
						const calculatedExchange = roomRateSum * activeCurrencyData.exchangeRate

						renderRoomRate = (
							<div>
								{ activeCurrencyData.currencySymbol ?
									activeCurrencyData.currencySymbol
								:
									getCurrencySymbol(activeCurrencyData.currencyCode)
								}
								{ formatPrice(calculatedExchange, 2) }
								{ renderCurrencyCode }
							</div>
						)
					} else {
						renderRoomRate = (
							<div>
								{ currencySymbol }
								{ formatPrice(roomRateSum, 2) }
								{ renderCurrencyCode }
							</div>
						)
					}
				}

				// Build Room Tax
				if (
					activeRoom[roomKey] &&
					!_.isNil(_.get(activeRoom[roomKey], '[1][0].rates[0].total.amountBeforeTax')) &&
					!_.isNil(_.get(activeRoom[roomKey], '[1][0].rates[0].total.amountAfterTax')) &&
					!isNaN(Number(_.get(activeRoom[roomKey], '[1][0].rates[0].total.amountBeforeTax'))) &&
					!isNaN(Number(_.get(activeRoom[roomKey], '[1][0].rates[0].total.amountAfterTax')))
				) {
					const roomTaxesFeesTotal = Number(activeRoom[roomKey][1][0].rates[0].total.amountAfterTax) - Number(activeRoom[roomKey][1][0].rates[0].total.amountBeforeTax)

					roomTaxesFeesData.push(Number(roomTaxesFeesTotal.toFixed(2)))
					const roomTaxesFeesSum = roomTaxesFeesData.reduce(addTotals, 0)

					if (
						yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
						activeCurrencyData &&
						activeCurrencyData.exchangeRate &&
						activeCurrencyData.currencyCode
					) {
						const calculatedExchange = roomTaxesFeesSum * activeCurrencyData.exchangeRate

						renderRoomTax = (
							<div>
								{ activeCurrencyData.currencySymbol ?
									activeCurrencyData.currencySymbol
								:
									getCurrencySymbol(activeCurrencyData.currencyCode)
								}
								{ formatPrice(calculatedExchange, 2) }
								{ renderCurrencyCode }
							</div>
						)
					} else {
						renderRoomTax = (
							<div>
								{ currencySymbol }
								{ formatPrice(roomTaxesFeesSum, 2) }
								{ renderCurrencyCode }
							</div>
						)
					}

				}

				// Build separate Taxes-only and Fees-only totals (used for the B5C3 split display)
				if (
					!_.isNil(_.get(activeRoom[roomKey], '[1][0].rates[0].total.viewExtensions.fees.amount')) &&
					!isNaN(Number(_.get(activeRoom[roomKey], '[1][0].rates[0].total.viewExtensions.fees.amount')))
				) {
					roomFeesOnlyData.push(Number(activeRoom[roomKey][1][0].rates[0].total.viewExtensions.fees.amount))
					const roomFeesOnlySum = roomFeesOnlyData.reduce(addTotals, 0)

					if (
						yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
						activeCurrencyData &&
						activeCurrencyData.exchangeRate &&
						activeCurrencyData.currencyCode
					) {
						const calculatedExchange = roomFeesOnlySum * activeCurrencyData.exchangeRate

						renderRoomFeesOnly = (
							<div>
								{ activeCurrencyData.currencySymbol ?
									activeCurrencyData.currencySymbol
								:
									getCurrencySymbol(activeCurrencyData.currencyCode)
								}
								{ formatPrice(calculatedExchange, 2) }
								{ renderCurrencyCode }
							</div>
						)
					} else {
						renderRoomFeesOnly = (
							<div>
								{ currencySymbol }
								{ formatPrice(roomFeesOnlySum, 2) }
								{ renderCurrencyCode }
							</div>
						)
					}
				}

				// Tax is derived as a residual (Room Total - Subtotal - Fees) rather than read
				// directly from total.taxes.amount, so Subtotal + Fees + Tax always reconciles
				// exactly to the Room Total regardless of whether the API's own tax/fee fields
				// independently sum to that total.
				if (
					!_.isNil(_.get(activeRoom[roomKey], '[1][0].rates[0].total.amountAfterTax')) &&
					!_.isNil(_.get(activeRoom[roomKey], '[1][0].rates[0].total.amountBeforeTax')) &&
					!isNaN(Number(_.get(activeRoom[roomKey], '[1][0].rates[0].total.amountAfterTax'))) &&
					!isNaN(Number(_.get(activeRoom[roomKey], '[1][0].rates[0].total.amountBeforeTax')))
				) {
					const roomFeesAmount = !_.isNil(_.get(activeRoom[roomKey], '[1][0].rates[0].total.viewExtensions.fees.amount')) &&
						!isNaN(Number(_.get(activeRoom[roomKey], '[1][0].rates[0].total.viewExtensions.fees.amount')))
						? Number(activeRoom[roomKey][1][0].rates[0].total.viewExtensions.fees.amount)
						: 0

					const roomTaxOnlyTotal = Math.max(0,
						Number(activeRoom[roomKey][1][0].rates[0].total.amountAfterTax) -
						Number(activeRoom[roomKey][1][0].rates[0].total.amountBeforeTax) -
						roomFeesAmount
					)

					roomTaxesOnlyData.push(roomTaxOnlyTotal)
					const roomTaxesOnlySum = roomTaxesOnlyData.reduce(addTotals, 0)

					if (
						yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
						activeCurrencyData &&
						activeCurrencyData.exchangeRate &&
						activeCurrencyData.currencyCode
					) {
						const calculatedExchange = roomTaxesOnlySum * activeCurrencyData.exchangeRate

						renderRoomTaxOnly = (
							<div>
								{ activeCurrencyData.currencySymbol ?
									activeCurrencyData.currencySymbol
								:
									getCurrencySymbol(activeCurrencyData.currencyCode)
								}
								{ formatPrice(calculatedExchange, 2) }
								{ renderCurrencyCode }
							</div>
						)
					} else {
						renderRoomTaxOnly = (
							<div>
								{ currencySymbol }
								{ formatPrice(roomTaxesOnlySum, 2) }
								{ renderCurrencyCode }
							</div>
						)
					}
				}

				//Build Grand Total
				if (activeRoom[roomKey][1][0].rates[0].total.amountAfterTax) {

					// Combine and add room totals
					roomTotalData.push(Number(activeRoom[roomKey][1][0].rates[0].total.amountAfterTax))

					// Build enhancement totals
					if (!_.isEmpty(activeEnhancementData)) {
						// Loop for related enhancements by roomGroup and roomType
						for (let enhancementKeys in activeEnhancementData) {
							if (
								Number(activeEnhancementData[enhancementKeys].roomGroup) === Number(roomKey) &&
								activeEnhancementData[enhancementKeys].roomType === activeRoom[roomKey][0][0].roomTypeCode
							) {
								if (_.get(activeEnhancementData, '[enhancementKeys].enhancementApiData.price[0].base.amountBeforeTax')) {
									enhancementTotalData.push(activeEnhancementData[enhancementKeys].enhancementApiData.price[0].base.amountBeforeTax)
								}
							}
						}
					}
				}

				// Construct detailed fees and taxes breakdown
				if (
					(yn(process.env.REACT_APP_COMPONENT_ENABLE_DETAILED_FEES_AND_TAXES) || highlightedTaxesFees) &&
					activeRoom[roomKey][1][0].rates[0].total &&
					activeRoom[roomKey][1][0].rates[0].total.taxes &&
					activeRoom[roomKey][1][0].rates[0].total.taxes.tax
				) {
					let rawFeesByCode = _.groupBy(activeRoom[roomKey][1][0].rates[0].total.taxes.tax, 'code')
					let feesByCode = []

					// Remove all tax & fee entries from displayed line items
					// if not set in highlightedTaxesFees array from property config
					// if (highlightedTaxesFees) {
					// 	Object.keys(rawFeesByCode).forEach(feeType => {
					// 		if (!_.includes(highlightedTaxesFees, String(feeType))) {
					// 			delete rawFeesByCode[feeType]
					// 		}
					// 	})
					// }


					for (const feeType in rawFeesByCode){
						const currentFeeGroup = rawFeesByCode[feeType]

						if (
							urlData &&
							urlData.startDate &&
							urlData.endDate &&
							currentFeeGroup[0].code &&
							(currentFeeGroup[0].chargeFrequency.toLowerCase() === 'per night' || currentFeeGroup[0].chargeFrequency.toLowerCase()) === 'per room per night' &&
							currentFeeGroup[0].amount &&
							currentFeeGroup[0].taxDescription &&
							currentFeeGroup[0].taxDescription[0] &&
							currentFeeGroup[0].taxDescription[0].text
						) {
							let groupFeeTotals = []

							for (const groupKey in currentFeeGroup) {
								const currentFeeEntry = currentFeeGroup[groupKey]
								let feeMultiplier = moment(urlData.endDate).diff(moment(urlData.startDate), 'days')

								if (
									currentFeeGroup[0].effectiveDate &&
									currentFeeGroup[0].expireDate
								) {
									feeMultiplier = moment(currentFeeEntry.expireDate).diff(moment(currentFeeEntry.effectiveDate), 'days') + 1
								}

								const feeAmount = currentFeeEntry.amount * Number(feeMultiplier)
								groupFeeTotals.push(feeAmount)
							}

							const feeGroupTotalSum = formatRoundPrice(groupFeeTotals.reduce(addTotals), 2)

							feesByCode.push(
								{
									code: currentFeeGroup[0].code,
									name: currentFeeGroup[0].taxDescription[0].text,
									amount: feeGroupTotalSum
								}
							)
						}
					}

					// Render fees breakdown DOM elements
					for (const feeKey in feesByCode) {
						const currentFee = feesByCode[feeKey]

						renderRoomFees.push(
							<div key={ 'roomFee-' + currentFee.code } className="u-price-line__row">
								<span className="u-price-line__label u-font-xs">
                  { currentFee.code !== "TCNTRR" ? currentFee.name : "10% GST inclusive" }:
                </span>
								<span className="u-price-line__val u-font-xs">
									{ currencySymbol }{ formatPrice(currentFee.amount, 2) }{ renderCurrencyCode }
								</span>
							</div>
						)
					}
				}

				// let roomRateTaxes = _.get(activeRoom[roomKey], '[1][0].rates[0].total.taxes.tax', [])
				// let roomRateDestinationFeeCode = _.get(activeRoom[roomKey], '[1][0]viewExtensions.resortDestinationFeeCode')

				// if (
				// 	yn(process.env.REACT_APP_COMPONENT_ENABLE_DESTINATION_FEES) &&
				// 	!_.isEmpty(roomRateTaxes) &&
				// 	roomRateDestinationFeeCode
				// ) {
				// 	let roomRateDestinationFee = roomRateTaxes.filter(tax => {
				// 		return Number(tax.code) === Number(roomRateDestinationFeeCode)
				// 	})

				// 	if (_.get(roomRateDestinationFee, '[0].amount')) {
				// 		destinationFeeAmount = roomRateDestinationFee[0].amount * totalNights

				// 		if (
				// 			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX)&&
				// 			activeCurrencyData.exchangeRate
				// 		) {
				// 			destinationFeeAmount = roomRateDestinationFee[0].amount * activeCurrencyData.exchangeRate * totalNights
				// 		}
				// 	}
				// }
			}

			// Reduce data arrays for single total sum
			const roomTotalsSum = roomTotalData.reduce(addTotals, 0)
			const enhancementTotalsSum = enhancementTotalData.reduce(addTotals, 0)

			// Create grand total data (add services to total based on config)
			if (yn(process.env.REACT_APP_COMPONENT_INCLUDE_SERVICES_IN_TOTAL)) {
				grandTotalData.push(roomTotalsSum, enhancementTotalsSum)
			} else {
				grandTotalData.push(roomTotalsSum)
			}

			// Reduce array for rate or rate and enhancements total
			const grandTotalSum = grandTotalData.reduce(addTotals)

			// Format render of grand total
			if (
				yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
				activeCurrencyData &&
				activeCurrencyData.exchangeRate &&
				activeCurrencyData.currencyCode
			) {
				const calculatedExchange = grandTotalSum * activeCurrencyData.exchangeRate

				renderGrandTotal = (
					<div>
						{ activeCurrencyData.currencySymbol ?
							activeCurrencyData.currencySymbol
						:
							getCurrencySymbol(activeCurrencyData.currencyCode)
						}
						{ formatPrice(calculatedExchange, 2) }
						{ renderCurrencyCode }
					</div>
				)
			} else {
				renderGrandTotal = <div>{ currencySymbol }{ formatPrice(grandTotalSum, 2) }{ renderCurrencyCode }</div>
			}

			let renderCrsGrandTotal = null

			if (
				yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
				String(activeCurrencyData.currencyCode) !== String(currencyCode)
			) {
				const crsGrandTotal = grandTotalData.reduce(addTotals, 0)

				if (crsGrandTotal && Number(crsGrandTotal) > 0) {
					renderCrsGrandTotal = (
						<div className="u-price-line__row">
							<span className="u-price-line__label u-font-bold u-font-xs">{ hotelLabels.crsBilledTotal ? hotelLabels.crsBilledTotal : 'Billed Total'}:</span>
							<span className="u-price-line__val u-font-bold u-font-xs">
								{ currencySymbol }{ formatPrice(crsGrandTotal, 2) } { currencyCode }
							</span>
						</div>
					)
				}
			}

			return (
        <div className="bk-flow-payment__summary">
          <div className="bk-flow-payment__summary-data u-flex u-flex--column u-price-line">
            <div className="u-price-line__row subtotal">
              <span className="u-price-line__label">{hotelLabels.subtotal ? hotelLabels.subtotal : 'Subtotal'}:</span>
              <span className="u-price-line__val">{renderRoomRate}</span>
            </div>

            {hideTaxes ?
              <Fragment>
                {renderRoomFeesOnly &&
                  <div className="u-price-line__row fees">
                    <span className="u-price-line__label">{hotelLabels.fees ? hotelLabels.fees : 'Fees'}:</span>
                    <span className="u-price-line__val">{renderRoomFeesOnly}</span>
                  </div>
                }
                {renderRoomTaxOnly &&
                  <div className="u-price-line__row taxes">
                    <span className="u-price-line__label">{hotelLabels.taxes ? hotelLabels.taxes : 'Taxes'}:</span>
                    <span className="u-price-line__val">{renderRoomTaxOnly}</span>
                  </div>
                }
              </Fragment>
            : renderRoomTax &&
              <div className="u-price-line__row taxes-fees">
									<span className="u-price-line__label">
										{process.env.REACT_APP_COMPONENT_PAYMENT_TAXES_FEES_FORMAT === 'taxes' ?
                      hotelLabels.taxes ? hotelLabels.taxes : 'Taxes'
                      :
                      <Fragment>
                        {hotelLabels.taxes ? hotelLabels.taxes : 'Taxes'}
                        &nbsp;&amp;&nbsp;
                        {hotelLabels.fees ? hotelLabels.fees : 'Fees'}
                      </Fragment>
                    }
                    {(yn(process.env.REACT_APP_COMPONENT_ENABLE_DETAILED_FEES_AND_TAXES) || highlightedTaxesFees) &&
                    renderRoomFees ?
                      hotelLabels.total ? ' ' + hotelLabels.total : ' Total'
                      :
                      null
                    }:
									</span>
                <span className="u-price-line__val">{renderRoomTax}</span>
              </div>
            }
            {destinationFeeAmount &&
              <div className="u-price-line__row-detailed destination-fee">
                <div className="u-price-line__row">
										<span className="u-price-line__label u-font-XS">
											{propertyClassType === 30 ?
                        hotelLabels.resortFee ? hotelLabels.resortFee : 'Resort Fee'
                        : propertyClassType === 47 ?
                          hotelLabels.amenityFee ? hotelLabels.amenityFee : 'Amenity Fee'
                          : propertyClassType === 26 ?
                            hotelLabels.sustainabilityFee ? hotelLabels.sustainabilityFee : 'Sustainability Fee'
                            :
                            hotelLabels.destinationFee ? hotelLabels.destinationFee : 'Destination Fee'
                      }
										</span>
                  <span className="u-price-line__val u-font-xs">
										{currencySymbol}{formatPrice(destinationFeeAmount, 2)}{renderCurrencyCode}
									</span>
                </div>
              </div>
            }

            {(yn(process.env.REACT_APP_COMPONENT_ENABLE_DETAILED_FEES_AND_TAXES) || highlightedTaxesFees) && !hideTaxes &&
            renderRoomFees ?
              <div className="u-price-line__row-detailed room-fees-detailed">{renderRoomFees}</div>
              :
              null
            }

            <div className="bk-flow-payment__summary-total u-price-line__row u-price-line__row-total">
              <span className="u-price-line__label">{hotelLabels.room} {hotelLabels.total}:</span>
              <span className="u-price-line__val">{renderGrandTotal}</span>
            </div>
            {renderCrsGrandTotal && renderCrsGrandTotal}
          </div>

          {activeRoom &&
            <div className="bk-flow-payment__sidebar-room-cards">
              {this.renderRoomCards()}
            </div>
          }
        
 		  { yn(process.env.REACT_APP_COMPONENT_ENABLE_RESTAURANT_RESERVATIONS) &&
			activeRestaurantsData &&
			Object.keys(activeRestaurantsData).length > 0 &&
				<BkFlowRestaurantsPaymentCards />
		  }

          {yn(process.env.REACT_APP_COMPONENT_PAYMENT_ROOM_POLICIES) &&
            <BkFlowSidebarPolicies
              configData={configData}
              availabilityLoading={availabilityLoading}
              activeRoom={activeRoom}
              roomRateDetailsData={roomRateDetailsData}
			  activeHotelCode={activeHotelCode}
            />
          }
        </div>
      )
    }
  }

  renderRoomCards = () => {
    const {activeRoom} = this.props

    // Begin Render Card Layouts
    return Object.keys(activeRoom).map(roomKey => {
      return (
        <BkFlowSidebarRoomCard key={roomKey} roomKey={ roomKey } />
			)
		})
	}

	render() {
		const { configData } = this.props
		const hotelLabels = configData.hotel.labels[0]

		return (
      <div className="bk-flow-payment__sidebar-content start-xs u-form-card">
        <h3>{hotelLabels.reservationSummary}</h3>
        {this.renderSidebar()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    configData: state.configData.configuration,
    multiRoomData: state.multiRoomData,
    availabilityLoading: state.availabilityData.loading,
    urlData: state.availabilityData.urlData,
		activeRoom: state.activeRoomData,
		activeRestaurantsData: state.activeRestaurantsData,
		activeEnhancementData: state.activeEnhancementData,
		activeCurrencyData: state.activeCurrencyData,
		roomRateDetailsData: state.roomRateDetailsData
	}
}

export default connect(mapStateToProps, null)(BkFlowPaymentSidebar)


// WEBPACK FOOTER //
// ./src/components/payment/sidebar/BkFlowPaymentSidebar.js